import { useContext } from "react";
import { Tag, Button, Tooltip } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/tr";
import { DrawerContext } from "@CONTEXTS";
import { CopyElement } from "@UI";

dayjs.locale("tr");
const useLogics = () => {
  const { setDrawer } = useContext(DrawerContext);
  const columns = [
    {
      title: "Belge Numarası",
      key: "e_invoice_number",
      dataIndex: "e_invoice_number",
      width: 100,
      fixed: true,
      render: (_, record) => {
        return (
          <div className="big-text-container">
            <div className="big-text">
              <Tooltip title="Fatura Detayı" placement="top">
                <Button
                  type="link"
                  style={{ padding: 0 }}
                  onClick={() =>
                    setDrawer({
                      ...record,
                    })
                  }
                >
                  {record?.e_invoice_number || "-"}
                </Button>
              </Tooltip>
              <CopyElement text={record?.e_invoice_number || "-"} />
            </div>
          </div>
        );
      },
    },
    {
      title: "Açıklama",
      key: "description",
      dataIndex: "description",
      width: 250,
      fixed: true,
    },
    {
      title: "Belge Kesim Tarihi",
      key: "created_date",
      dataIndex: "created_date",
      width: 100,
      render: (date) => dayjs(date).format("DD MMMM YYYY"),
    },
    {
      title: "Vade Tarihi",
      key: "net_due_date",
      dataIndex: "net_due_date",
      width: 100,
      render: (date) =>
        dayjs(date).isValid() ? dayjs(date).format("DD MMMM YYYY") : "-",
    },
    {
      title: "Kalan Tutar",
      key: "remaining_amount",
      dataIndex: "remaining_amount",
      width: 100,
      align: "right",
      render: (amount) => {
        const formatted = new Intl.NumberFormat("tr-TR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(amount));

        return `${formatted} ₺`;
      },
    },
    {
      title: "Durum",
      key: "payment_status",
      dataIndex: "payment_status",
      width: 100,
      render: (status) => {
        let color = "default";

        switch (status) {
          case "Ödendi":
            color = "green";
            break;
          case "Ödenmedi":
            color = "red";
            break;
          case "Kısmi Ödendi":
            color = "orange";
            break;
          default:
            color = "default";
        }

        return (
          <Tag
            color={color}
            style={{ borderRadius: 8, width: "100%", textAlign: "center" }}
          >
            ● {status}
          </Tag>
        );
      },
    },
  ].filter(Boolean);

  const excelColumns = [];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
